import { ContentStateInterface } from '../../../../../../@types/types'
import { RealEstateLocation } from '../../../../../../@types/real-estate-api-types'

export const locationToApi = (insertionData: ContentStateInterface): RealEstateLocation => {
  return {
    distanceToAirport: insertionData.distanceToAirport ? String(insertionData.distanceToAirport) : undefined,
    distanceToFM: insertionData.distanceToFM ? String(insertionData.distanceToFM) : undefined,
    distanceToMRS: insertionData.distanceToMRS ? String(insertionData.distanceToMRS) : undefined,
    distanceToPT: insertionData.distanceToPT ? String(insertionData.distanceToPT) : undefined,
  }
}
